/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An admin adds a guest that is not in the member register, for example someone who calls in.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto {
    /**
     * The event to add the guest to.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto
     */
    eventId?: number;
    /**
     * Name of the guest.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto
     */
    name?: string | null;
    /**
     * E-mail of the guest. Optional.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto
     */
    email?: string | null;
    /**
     * Phone number of the guest. Optional.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto
     */
    phone?: string | null;
    /**
     * The times the guest takes part in. A fully booked time puts the guest on the waitlist.
     * @type {Array<number>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto
     */
    timeIds?: Array<number> | null;
    /**
     * Note from the admin, saved as the message of the reply.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto
     */
    note?: string | null;
    /**
     * True to send a confirmation to the guest. Ignored when the guest has no e-mail.
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto
     */
    sendConfirmation?: boolean;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto {
    return WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'timeIds': !exists(json, 'timeIds') ? undefined : json['timeIds'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'sendConfirmation': !exists(json, 'sendConfirmation') ? undefined : json['sendConfirmation'],
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceAddGuestReplyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventId': value.eventId,
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
        'timeIds': value.timeIds,
        'note': value.note,
        'sendConfirmation': value.sendConfirmation,
    };
}

